import { FC } from 'react'
import { Flex } from "@chakra-ui/react"
import {ProductBookCard} from './components/ProductBookCard'

type TProductItem = {
  type: 'book';
  id: string;
  slugUrl: string;
  productInfo: {
    title: string;
    author: string;
    variant: 'ebook' | 'książka' | 'ebook + książka';
  };
  images: {
    src: string;
    alt: string;
    type?: 'product-cover'
  }[],
  priceInfo: {
    regularPrice: string;
    discountPrice?: string;
  }
}

export const ShopSection: FC<{productsList: TProductItem[]; priority: 'high' | 'low'}> = ({productsList, priority}) => {
  return (
    <Flex
      justify={{ base: "center" }}
      direction={{ base: "row" }}
      alignItems={'center'}
      flexFlow={'wrap'}
      gap={2}
      my={2}
    >

      {productsList.map(product => {
        if (product.type === 'book') {
          return (
            <ProductBookCard
              priority={priority}
              key={product.id}
              product={product}
            />      
          )
        }

        return null
      })}
    </Flex>
  )
}